import Lookup from 'src/componentes/select-async';
import CentroCustoList from 'src/paginas/matriz-orcamentaria/centro-custo';
import CentroCustoEdit from 'src/paginas/matriz-orcamentaria/centro-custo/edit';

const CentroCustoLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="nome"
      showSearch
      clearable={true}
      url="/CentroCustoLookup"
      editComponent={CentroCustoEdit}
      searchComponent={CentroCustoList}
      hierarchy
      {...props}
    />
  );
};

export default CentroCustoLookup;
